import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Featured.scss";

const Featured = () => {
  const [query, setQuery] = useState("");

  const navigate = useNavigate();

  const handleSearch = (e) => {
    navigate(`/gigs?search=${query}`);
  };

  return (
    <div className="featured">
      <div className="featured-container">
        <div className="featured-left">
          <h1>
            Find the perfect <span>freelance</span> services for your business
          </h1>
          <form onSubmit={handleSearch} className="featured-left-search">
            <div className="featured-left-search-input">
              <img src="/img/search.png" alt="search" />
              <input
                type="text"
                placeholder="Search gigs by title"
                onChange={(e) => setQuery(e.target.value)}
              />
            </div>
            <button type="submit">Search</button>
          </form>
          <div className="featured-left-popular">
            <span>Popular:</span>
            <button>Web Design</button>
            <button>WordPress</button>
            <button>Logo Design</button>
            <button>AI Services</button>
          </div>
        </div>

        <div className="featured-right">
          <img src="/img/man.png" alt="man" />
        </div>
      </div>
    </div>
  );
};

export default Featured;
